import { ContentState, convertFromRaw, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

// Stored chat history can contain either Draft.js data or plain webhook replies.
export const getChatMessageContent = (message) => {
  const text = typeof message === "string"
    ? message
    : message == null ? "" : JSON.stringify(message);

  try {
    const raw = typeof message === "string" ? JSON.parse(message) : message;
    if (
      raw &&
      Array.isArray(raw.blocks) &&
      raw.blocks.length > 0 &&
      raw.blocks.every((block) => block && typeof block.text === "string")
    ) {
      return convertFromRaw({ ...raw, entityMap: raw.entityMap || {} });
    }
  } catch {
    // Plain text and malformed rich text remain readable instead of crashing chat.
  }

  return ContentState.createFromText(text);
};

export const getChatMessageHtml = (message) =>
  draftToHtml(convertToRaw(getChatMessageContent(message)));
